<template>
  <div id="page-product-details">
    <section-ancestors-additive-form
        v-model="model"
        ref="form"
        :loading="loading"
        @deleteAncestor="deleteAncestor"
    />
  </div>
</template>

<script>

import NotificationMixin from '@/components/mixins/NotificationMixin';
import ViewModelMixin from '@/components/mixins/ViewModelMixin';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import SectionAncestorsAdditiveForm from '@/views/pages/facilities/sections/ancestors/SectionAncestorsAdditiveForm';
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

export default {
  name: "SectionAncestors",
  components: {
    SectionAncestorsAdditiveForm,
  },
  mixins: [SaveModelMixin, ViewModelMixin, NotificationMixin, CanAccessMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.facilities.sections,
      entity: 'Section Ancestors',
      componentAccess: {
        canEdit: {
          route: 'facilities.sections.ancestors.edit',
          access: false,
        },
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.sectionId;
    }
  },
  methods: {
    async getParams() {
      const params = this.getModelCopy(true);

      const multiReferences = [
        {
          array: 'ancestors',
          key: ['SectionParent_FK'],
        },
      ];

      await this.setMultiReferences(multiReferences);

      params.ancestors.forEach((row) => delete row.Facility_FK)

      delete params.Facility_FK;
      delete params.Section_FK;

      return params;
    },
    async fetch() {
      try {
        const { data } = await this.$api.facilities.sections.ancestors(this.id)
        this.model = {
          id: this.id,
          ancestors: await data.data.map(({facility_section, SectionParent_FK, id}) => {
            return ({pivot: {Facility_FK: facility_section.Facility_FK, SectionParent_FK, id}});
          }),
        }
      } catch (e) {
        console.log(e);
      }
    },
    async deleteAncestor(ancestorId) {
      this.loading = true;

      try {
        const {data} = await this.$api.facilities.sections.deleteAncestor(
            this.$route.params.sectionId,
            ancestorId
        );

        this.notifySuccess('Section Ancestor updated');
      } catch (e) {
        this.notifyError('Section Ancestor failed to be update');
        console.error(e)
      } finally {
        await this.reloadForm();

        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
